import React, { useState } from 'react';
import styles from './ReactionThreadPopOver.module.scss';
import ThreadReactionList from './ThreadReactionList';
import type { DocumentType } from '../../graphql/generated';
import { gql } from '../../graphql/generated';
import ReactionThreadMenu from './ReactionThreadMenu';
import PopOverContainer from '../../components/deprecated/PopOverContainer';

const POST_FRAGMENT = gql(`
  fragment ReactionThreadPopOver_post on RootPostFields {
    id
    ...ReactionThreadMenu_post
  }
`);

const THREAD_FRAGMENT = gql(`
  fragment ReactionThreadPopOver_thread on PublicThreadFields {
    id
    ...ThreadReactionList_thread
    ...ReactionThreadMenu_thread
  }
`);

interface ReactionThreadPopOverProps {
  thread: DocumentType<typeof THREAD_FRAGMENT>;
  post: DocumentType<typeof POST_FRAGMENT>;
  expanded: boolean;
}

const ReactionThreadPopOver = ({
  thread,
  post,
  expanded,
}: ReactionThreadPopOverProps) => {
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);

  return (
    <PopOverContainer noPadding width="auto" overflow="visible">
      <div className={styles.innerContainer}>
        <ThreadReactionList
          expanded={expanded}
          thread={thread}
          withinOverlay
          onEmojiPickerOpenChange={setIsEmojiPickerOpen}
          isEmojiPickerOpen={isEmojiPickerOpen}
          renderMenuButton={(button) => (
            <ReactionThreadMenu thread={thread} post={post} button={button} />
          )}
        />
      </div>
    </PopOverContainer>
  );
};

export default ReactionThreadPopOver;
